var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.9999C12.6569 13.9999 14 12.6568 14 10.9999C14 9.34308 12.6569 7.99994 11 7.99994C9.34315 7.99994 8 9.34308 8 10.9999C8 12.6568 9.34315 13.9999 11 13.9999Z",
    stroke: "#75848A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.8799V10.1199C1 9.07994 1.85 8.21994 2.9 8.21994C4.71 8.21994 5.45 6.93994 4.54 5.36994C4.02 4.46994 4.33 3.29994 5.24 2.77994L6.97 1.78994C7.76 1.31994 8.78 1.59994 9.25 2.38994L9.36 2.57994C10.26 4.14994 11.74 4.14994 12.65 2.57994L12.76 2.38994C13.23 1.59994 14.25 1.31994 15.04 1.78994L16.77 2.77994C17.68 3.29994 17.99 4.46994 17.47 5.36994C16.56 6.93994 17.3 8.21994 19.11 8.21994C20.15 8.21994 21.01 9.06994 21.01 10.1199V11.8799C21.01 12.9199 20.16 13.7799 19.11 13.7799C17.3 13.7799 16.56 15.0599 17.47 16.6299C17.99 17.5399 17.68 18.6999 16.77 19.2199L15.04 20.2099C14.25 20.6799 13.23 20.3999 12.76 19.6099L12.65 19.4199C11.75 17.8499 10.27 17.8499 9.36 19.4199L9.25 19.6099C8.78 20.3999 7.76 20.6799 6.97 20.2099L5.24 19.2199C4.33 18.6999 4.02 17.5299 4.54 16.6299C5.45 15.0599 4.71 13.7799 2.9 13.7799C1.85 13.7799 1 12.9199 1 11.8799Z",
    stroke: "#75848A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5ca9c2c280c6c09e5d89d72d31ab62a9.svg";
export { ForwardRef as ReactComponent };